import classNames from "classnames";
import { html, TemplateResult } from "lit-html";

export interface Props {
	dataTestId?: string;
	isAction: boolean;
	icon: TemplateResult;
	isDisabled?: boolean;
	label: string;
	onClick: () => void | Promise<void>;
}

export const iconButton = (props: Props) => {
	const handleClick = async (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();

		if (props.isDisabled) return;

		await props.onClick();
	};

	const htmlTemplate = () => html`
		<div
			class=${classNames(
				"flex h-[42px] w-full cursor-pointer select-none whitespace-nowrap items-center justify-center rounded-full px-5 text-white common-transition",
				"sm:w-auto",
				{
					"bg-n-blue text-sm/none font-semibold": !props.isAction,
					"hover:bg-n-cyan": !props.isAction,
					"bg-[#af272f] text-lg/none": props.isAction,
					"hover:bg-n-blue": props.isAction,
					"opacity-50 cursor-not-allowed pointer-events-none": props.isDisabled,
				}
			)}
			data-test-id=${props.dataTestId || ""}
			@click=${handleClick}
		>
			<div class="mr-2 font-body">${props.label}</div>
			${props.icon}
		</div>
	`;

	return { htmlTemplate };
};
